module.exports = __webpack_public_path__ + "static/media/logo.ee6baa88.svg";